<template>
    <mw-dialog  size="" title="并行发送" :footerButton="footerButton" ref="dialog">
      <div style="padding: 10px;">
        <el-form :model="editingForm" label-width="150px" :rules="editingRule" ref="editingFormRef">
          <el-form-item label="完成节点" prop="oneNode">
            <el-select  v-model="editingForm.oneNode" style="width:100%">
              <el-option
                v-for="item in unfinishedTaskQueue"
                :key="item.id"
                :label="`${item.name||''}-${item.department||''}-${item.candidateName||''}`.replace(/-$|^-|--/g, '')"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="完成办理人" prop="oneMan">
            <el-select  v-model="editingForm.oneMan" style="width:100%">
              <el-option
                v-for="item in taskTransactorList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="送至节点" prop="twoNode">
            <el-select  v-model="editingForm.twoNode" style="width:100%">
              <el-option
                v-for="item in nextFlowList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="办理人" prop="twoMan">
            <man-select v-model="editingForm.twoMan" :url="twoManUrl" :multiple="twoManMultiple"/>
          </el-form-item>

        </el-form>
      </div>
    </mw-dialog>
</template>

<script>
import api from "@/common/api/maintain";
import ManSelect from "../common/manSelect";
export default {
  data() {
    return {
      editingForm: {
        oneNode: "", // taskId
        oneMan: "",

        twoNode: "", // flowId
        twoMan: [],
        twoNodeOption:{}
      },
      unfinishedTaskQueue: [],
      taskTransactorList: [],
      nextFlowList: [],
      editingRule: {
        oneNode: [{ required: true, message: "请选择完成节点" }],
        twoNode: [{ required: true, message: "请选择完成办理人" }],
        oneMan: [{ required: true, message: "请选择送至节点" }],
        twoMan: [
          {
            validator: (rule, value, callback) => {
              if (!value || !value.length) {
                callback("请选择办理人");
              } else {
                callback();
              }
            }
          }
        ]
      },
      footerButton: [
        {
          label: "确定",
          func: async () => {
            if (await this.mwRef("editingFormRef").validate()) {
              const taskId = this.editingForm.oneNode;
              const assigneeName = (() => {
                for (let i = 0; i < this.taskTransactorList.length; i++) {
                  if (
                    this.taskTransactorList[i].id === this.editingForm.oneMan
                  ) {
                    return this.taskTransactorList[i].name;
                  }
                }
                return "";
              })();
              const { activityId, type } = (() => {
                for (let i = 0; i < this.nextFlowList.length; i++) {
                  if (this.nextFlowList[i].id === this.editingForm.twoNode) {
                    return this.nextFlowList[i];
                  }
                }
                return {};
              })();
              const items = [];
              this.editingForm.twoMan.forEach(d => {
                if (d.type === "U") {
                  searchScope: {
                    for (let i = 0; i < items.length; i++) {
                      if (items[i].group === d.parentId) {
                        items[i].users.push({ id: d.id });
                        break searchScope;
                      }
                    }
                    // if no avaliable item found, create one
                    items.push({
                      group: d.parentId,
                      users: [{ id: d.id }]
                    });
                  }
                } else if(d.identities){
                  let users = [],
                    identities = [];
                  for (let iden of d.identities || []) {
                    if (iden.type == "U") {
                      users.push({ id: iden.id });
                    } else {
                      identities.push({ id: iden.id });
                    }
                  }
                  items.push({
                    group: d.id,
                    users,
                    identities
                  });
                }
              });
              const params = {
                assignee: this.editingForm.oneMan,
                assigneeName,
                activities: [
                  {
                    flowId: this.editingForm.twoNode,
                    activityId,
                    type,
                    items,
                    options:this.editingForm.twoNodeOption
                  }
                ],
                formOpenSource: 'pc:company-index.flowInterfering.jump2concurrenceFlow'
              };

              if ((await api.startSubProcess(taskId, params)).success) {
                this.mwMsg("发送成功");
                this.$emit('updateTable');
                this.mwRef("dialog").hide();
              }
            }
          }
        }
      ],

      applicationId: "",
      businessId: "",
      batchId:'',
      moduleId: ""
    };
  },
  computed: {
    twoManUrl() {
      const taskId = this.editingForm.oneNode;
      const flowId = this.editingForm.twoNode;
      return this.mwUrl(`/rest/process/task/flow/${taskId}/${flowId}`);
    },
    twoManMultiple() {
      for (let i = 0; i < this.nextFlowList.length; i++) {
        if (this.nextFlowList[i].id === this.editingForm.twoNode) {
          return this.nextFlowList[i].options.multipleUnit;
        }
      }
      return false;
    }
  },
  watch: {
    async "editingForm.oneNode"(nv, ov) {
      if (nv !== ov) {
        this.editingForm = {
          ...this.editingForm,
          oneMan: "",
          twoNode: "",
          twoMan: []
        };
        if (nv) {
          this.getTaskTransactorList(nv);
          this.getNextFlowList(nv);
        }
      }
    },

    async "editingForm.twoNode"(nv, ov) {
      if (nv !== ov) {
        this.editingForm = {
          ...this.editingForm,
          twoMan: []
        };
      }
    }
  },
  methods: {
    async action({ applicationId, businessId, batchId, moduleId }) {
      this.applicationId = applicationId;
      this.businessId = businessId;
      this.batchId  =batchId;
      this.moduleId = moduleId;
      this.editingForm = {
        oneNode: "",
        oneMan: "",

        twoNode: "",
        twoMan: []
      };
      this.mwRef("dialog").show();

      this.getUnfinishedTaskQueue();
    },

    async getUnfinishedTaskQueue() {
      this.unfinishedTaskQueue = [];
      this.unfinishedTaskQueue =
        (await api.listUnfinishedTask(this.batchId, { type: 1})).result ||
        [];
      // must update it manully
      if (!this.editingForm.oneNode && this.unfinishedTaskQueue[0]) {
        this.editingForm = {
          ...this.editingForm,
          oneNode: this.unfinishedTaskQueue[0].id
        };
      }
    },

    async getTaskTransactorList(taskId) {
      if (!taskId) return;
      this.taskTransactorList = [];
      this.taskTransactorList = (await api.listTaskTransactor(
        taskId,
        {}
      )).result;
      // must update it manully, select the first option like the browser default action
      if (!this.editingForm.oneMan && this.taskTransactorList[0]) {
        this.editingForm = {
          ...this.editingForm,
          oneMan: this.taskTransactorList[0].id
        };
      }
    },

    async getNextFlowList(taskId) {
      if (!taskId) return;
      this.nextFlowList = [];
      this.nextFlowList = (await api.getNextFlows(taskId, {
        types: ["startSubProcess"]
      })).result;
      // must update it manully, select the first option like the browser default action
      if (!this.editingForm.twoNode && this.nextFlowList[0]) {
        this.editingForm = {
          ...this.editingForm,
          twoNode: this.nextFlowList[0].id,
          twoNodeOption:this.nextFlowList[0].options
        };
      }
    }
  },

  components: {
    ManSelect
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/flowInterfering/actions/jump2concurrenceFlow.vue